import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';

interface ReasonForRejectionDialogProps {
  open: boolean;
  onClose: () => void;
  onReject: (reason: string) => void;
}

function ReasonForRejectionDialog({
  open,
  onClose,
  onReject,
}: ReasonForRejectionDialogProps) {
  const [selectedReason, setSelectedReason] = useState('');

  const handleReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedReason(event.target.value);
  };

  const handleReject = () => {
    if (selectedReason) {
      onReject(selectedReason);
      setSelectedReason('');
    }
  };

  const handleCancel = () => {
    setSelectedReason('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reason for rejection</DialogTitle>

      <DialogContent>
        <FormControl component="fieldset">
          <RadioGroup
            value={selectedReason}
            onChange={handleReasonChange}
            sx={{ mt: 1 }}>
            <FormControlLabel
              value="Decommissioning"
              control={<Radio />}
              label="Decommissioning - no longer needed"
            />
            <FormControlLabel
              value="Reassignment"
              control={<Radio />}
              label="Reassignment - out of managed scope"
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleReject}
          variant="contained"
          color="error"
          disabled={!selectedReason}>
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReasonForRejectionDialog;